<template>
  <div class="position-box">
    <div class="hostory">
      <p>当前定位城市</p>
      <div class="citybox">
        <button
          class="location"
          :disabled="!canUseLocation"
          @click="changeCity(location)"
        >
          {{ location.name }}
        </button>
        <button
          class="relocation"
          :disabled="locating"
          @click="reGetLocation"
        >
          <span class="relocation-icon"></span>
          {{ locating ? '定位中...' : retryActionText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, ref } from 'vue';
import {
  getLocationErrorMessage,
  getLocationRetryActionText,
  requestCurrentLocation
} from '../common/js/location';

defineOptions({name: 'PositionBox'});

const props = defineProps({
  location: {
    type: Object,
    default: () => ({
      name: '定位失败',
      id: 1,
      latitude: '',
      longitude: ''
    })
  }
});

const emit = defineEmits(['changeCity', 'locationError']);
const locating = ref(false);
let disposed = false;

const canUseLocation = computed(() => !!(
  props.location &&
  props.location.name &&
  props.location.name !== '定位失败'
));
const retryActionText = computed(() => getLocationRetryActionText());

onBeforeUnmount(() => {
  disposed = true;
});

function changeCity (city) {
  if (city && city.name && city.name !== '定位失败') {
    emit('changeCity', city);
  }
}

async function reGetLocation () {
  if (locating.value) {
    return;
  }

  locating.value = true;
  try {
    const city = await requestCurrentLocation();
    if (!disposed) {
      emit('changeCity', Object.assign({}, city, {isLocatedCity: true}));
    }
  } catch (error) {
    const message = getLocationErrorMessage(error);
    if (!disposed) {
      emit('locationError', message);
      alert(message);
    }
  } finally {
    if (!disposed) {
      locating.value = false;
    }
  }
}
</script>
<style scoped>
.position-box {
  background: var(--page-bg);
}
.position-box > .hostory {
  height: 60px;
  padding: 0px 10px 0px 10px;
  box-sizing: border-box;
}
.position-box > .hostory > p {
  line-height: 30px;
  color: var(--text-muted);
}
.position-box > .hostory > .citybox {
  height: 30px;
  box-sizing: border-box;
  padding-top: 0px;
  display: flex;
}
.position-box > .hostory > .citybox > .location {
  box-sizing: border-box;
  border-radius: 4px;
  outline: none;
  height: 30px;
  margin: 0px;
  background: var(--surface-bg);
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  flex: 1;
  min-width: 0;
}
.position-box > .hostory > .citybox > .location:disabled {
  color: var(--text-faint);
}
.position-box > .hostory > .citybox > .relocation {
  box-sizing: border-box;
  border-radius: 4px;
  outline: none;
  height: 30px;
  margin: 0px;
  background: var(--surface-bg);
  color: var(--text-secondary);
  flex: 0 0 auto;
  margin-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  min-width: 92px;
}
.position-box > .hostory > .citybox > .relocation:disabled {
  color: var(--text-faint);
}
.relocation-icon {
  width: 12px;
  height: 12px;
  border: 2px solid var(--accent-color);
  border-right-color: transparent;
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-block;
  margin-right: 4px;
}
</style>
